export const areaList = [
  {
    name: '兰州市',
    id: '兰州市'
  },
  {
    name: '嘉峪关市',
    id: '嘉峪关市'
  },
  {
    name: '金昌市',
    id: '金昌市'
  },
  {
    name: '白银市',
    id: '白银市'
  },
  {
    name: '天水市',
    id: '天水市'
  },
  {
    name: '武威市',
    id: '武威市'
  },
  {
    name: '张掖市',
    id: '张掖市'
  },
  {
    name: '酒泉市',
    id: '酒泉市'
  },
  {
    name: '平凉市',
    id: '平凉市'
  },
  {
    name: '庆阳市',
    id: '庆阳市'
  },
  {
    name: '定西市',
    id: '定西市'
  },
  {
    name: '陇南市',
    id: '陇南市'
  },
  {
    name: '临夏回族自治州',
    id: '临夏回族自治州'
  },
  {
    name: '甘南藏族自治州',
    id: '甘南藏族自治州'
  }
];
